import { render, staticRenderFns } from "./RmrFileInput.vue?vue&type=template&id=bf08ab60&scoped=true&"
import script from "./RmrFileInput.vue?vue&type=script&lang=js&"
export * from "./RmrFileInput.vue?vue&type=script&lang=js&"
import style0 from "./RmrFileInput.vue?vue&type=style&index=0&id=bf08ab60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf08ab60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
